import { storeToRefs } from 'pinia';

import { useCompanyStore } from '@/piniaStores/company/company.store';
import { useUserStore } from '@/piniaStores/user/user.store';

export function canStaffAccessManageLicenses() {
  const companyStore = useCompanyStore();
  const userStore = useUserStore();

  const { activeCompany } = storeToRefs(companyStore);

  const { getIsSplitEnabled: isSplitEnabled, user, userActiveCompany } = storeToRefs(userStore);

  return (
    !userActiveCompany.value?.staffIsAdmin &&
    user.value.permissions.seedToSale.canAccessSeedToSaleIntegration &&
    activeCompany.value?.seedToSaleVendor === 'BioTrack' &&
    activeCompany.value?.state === 'NY' &&
    isSplitEnabled.value('traceability_pod__biotrack_new_york')
  );
}
